import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { environment } from "../../../environments/environment";
import { JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import $ from "jquery";



@Component({
  selector: 'app-signin-component',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  standalone: false
})
export class SignInComponent implements OnInit, AfterViewInit {
  loginForm!: FormGroup;
  signedIn: boolean = false;
  loading: boolean = false;
  authFailedError: string | undefined | null;


  checkingCredential: boolean = false;

  returnUrl: string | undefined | null;

  
  constructor(private authService: AuthService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private alertService: AlertService) {
  }


  ngOnInit(): void {

    console.debug('SignInComponent.ngOnInit');

    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];

      if (this.returnUrl)
        console.debug('URL returnUrl', this.returnUrl);
    });
    

    
    this.loginForm = this.formBuilder.group(
      {
        username: [this.authService.userInfo?.UserName|| '', [Validators.required]],
        password: ['', [Validators.required]]
      });

    

    // get return url from route parameters or default to '/'

    if (this.authService.isSignedIn()) {
      console.info('isSignedIn');
      this.authService.getUserInfo().subscribe(x => {
        this.authService.redirectAfterLogin(x, this.returnUrl);
      });
    }
    else if (this.authService.tokenInfo
      && this.authService.tokenInfo.refresh_token) {

      if (this.authService.tokenInfo.refresh_expires_at != null
        && new Date(this.authService.tokenInfo.refresh_expires_at) > new Date()) {
        this.checkingCredential = true;
        console.debug('Initial checking credential', this.authService.tokenInfo?.refresh_token);
        this.authService.getTokenInfo()
          .forEach(response => {
            console.debug('New credential', this.authService.tokenInfo?.refresh_token);
            this.authService.getUserInfo().subscribe(x => {
              this.authService.redirectAfterLogin(x, this.returnUrl);
            });
          })
          .catch(
            err => {
              this.checkingCredential = false;
              this.alertService.error(err.Message || 'You are logged on another device.');
            })
          .finally(() => {

            //
          });
      } else {
        this.authFailedError = 'Your session has expired. Please sign in again.';
      }
    }
  }

  ngAfterViewInit(): void {
    
    console.debug('SignInComponent.AfterViewInit');
  }

  public signIn(_: any) {
    /*
    if (!this.loginForm.valid) {
      return;
    }
    */
    const userName = this.loginForm.get('username')?.value;
    const password = this.loginForm.get('password')?.value;
    this.loading = true;
    this.authFailedError = null;
    this.authService.signIn(userName, password).forEach(
      response => {
        this.authService.getUserInfo().subscribe(x => {
          this.authService.redirectAfterLogin(x, this.returnUrl);
        });
        
      }).catch(
        err => {
          this.alertService.error(err.Message || 'Invalid credentials');
          this.authFailedError = err.Message || 'Invalid credentials';
          this.loading = false;
        }).
      finally(() => {
      });

  }

  
  passwordReset() {
    console.warn('passwordReset');
    this.loading = true;
    // this.showFire = true;
    $(".itsfine").fadeIn({ duration: 2500 });
    $(".loginForm").fadeOut({ duration: 2500 });
    this.alertService.success("Congratulations! You've successfully tested the limits of your memory and found them lacking. Your password has managed to elude you yet again. Fear not, for this is merely a reminder that even in a world of advanced technology, some things never change. Time to embark on the grand adventure of password recovery. Good luck, brave soul. May the password gods be ever in your favor.", false);
    
  }

}
